import { AxiosResponse } from 'axios';
import { IncomingHttpHeaders } from 'http';
import { TitleMetaResponse } from '@doda/api-client/aspida/@types';
import { appAxios } from '../libs/axios/appAxios';

export const getSearchMetaTag = async (
  url: string,
  headers?: IncomingHttpHeaders
) => {
  return appAxios({
    url: '/api/v1/front/job/search/titlemeta',
    headers,
    params: { url },
  })
    .then((res: AxiosResponse<TitleMetaResponse>) => {
      return res.data;
    })
    .catch(() => {
      return {
        title: '',
        keyword: '',
        description: '',
        descriptionNextPage: '',
      };
    });
};
